import * as firebase from 'firebase/app';
import Student from '../models/Student.js';
require('firebase/firestore');

const state = {
  student: {},
  students: [],
  ageData: {
    series: [{
      name: 'Students',
      data: [0, 0, 0, 0, 0, 0, 0]
    }],
    options: {
      title: {
        text: 'Age'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'top'
          }
        }
      },
      xaxis: {
        categories: ['1-9', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69']
      }
    }
  },
  rankData: {
    series: [0, 0, 0, 0, 0, 0, 0],
    options: {
      title: {
        text: 'Rank'
      },
      colors: ['#c1c1c1', '#efe300', '#ffa100', '#207c1f', '#cc1100', '#006ee5', '#001156'],
      labels: ['White', 'Yellow', 'Orange', 'Green', 'Red',
        'Cho-Dan Bo', 'Black'
      ]
    }
  },
  genderData: {
    series: [0, 0],
    options: {
      title: {
        text: 'Gender'
      },
      labels: ['Male', 'Female']
    }
  }
};

const getters = {
  getStudent: state => state.student,
  getStudents: state => state.students,
  getAgeData: state => state.ageData,
  getRankData: state => state.rankData,
  getGenderData: state => state.genderData
};

const actions = {
  getAllStudents({
    commit
  }) {
    firebase.firestore().collection("students").onSnapshot(
      snapshot => {
        commit("setLoading", true);

        let students = [];
        let ageDict = {
          "1-9": 0,
          "10-19": 0,
          "20-29": 0,
          "30-39": 0,
          "40-49": 0,
          "50-59": 0,
          "60-69": 0,
        };
        let rankDict = {
          "White": 0,
          "Yellow": 0,
          "Orange": 0,
          "Green": 0,
          "Red": 0,
          "Blue": 0,
          "Black": 0
        };
        let genderDict = {
          Male: 0,
          Female: 0
        };

        snapshot.forEach(doc => {
          var data = doc.data();
          let s = new Student(
            doc.id,
            data.nameFirst,
            data.nameLast,
            data.address,
            data.city,
            data.state,
            data.zip,
            data.phone,
            data.cellPhone,
            data.emergencyPhone,
            data.email,
            data.dob,
            data.gender,
            data.startDate,
            data.rank,
            data.testNumber,
            data.beltSize,
            data.ITFnumber,
            data.lastTest,
            data.referral,
            data.active);
          students.push(s);

          // age
          let age = calcAge(s.dob);
          if (age <= 9) {
            ageDict["1-9"]++;
          } else if (age > 10 && age <= 19) {
            ageDict["10-19"]++;
          } else if (age > 20 && age <= 29) {
            ageDict["20-29"]++;
          } else if (age > 30 && age <= 39) {
            ageDict["30-39"]++;
          } else if (age > 40 && age <= 49) {
            ageDict["40-49"]++;
          } else if (age > 50 && age <= 59) {
            ageDict["50-59"]++;
          } else if (age > 60 && age <= 69) {
            ageDict["60-69"]++;
          }

          //rank
          let rankNumber = parseInt(s.rank.replace(/\D/g, ''));
          switch (rankNumber) {
            case 10:
              rankDict["White"]++;
              break;
            case 9:
              rankDict["Yellow"]++;
              break;
            case 8:
            case 7:
              rankDict["Orange"]++;
              break;
            case 6:
            case 5:
            case 4:
              rankDict["Green"]++;
              break;
            case 3:
            case 2:
            case 1:
              rankDict["Red"]++;
              break;
            default:
              if (s.rank.endsWith('Bo')) {
                rankDict["Blue"]++;
              } else {
                rankDict["Black"]++;
              }
              break;
          }

          // gender
          if (s.gender === "Male") {
            genderDict.Male++;
          } else {
            genderDict.Female++;
          }
        });
        commit("setStudents", students);

        // set graph data
        commit("setAgeData", ageDict);
        commit("setRankData", rankDict);
        commit("setGenderData", genderDict);

        commit("setLoading", false);
      },
      error => {
        commit("setLoading", false);
        console.error(error);
      });
  },
  createStudent({
    commit
  }, student) {
    let id = 0;

    firebase.firestore().collection("students").add({
        nameFirst: student.nameFirst,
        nameLast: student.nameLast,
        address: student.address,
        city: student.city,
        state: student.state,
        zip: student.zip,
        phone: student.phone,
        cellPhone: student.cellPhone,
        emergencyPhone: student.emergencyPhone,
        email: student.email,
        dob: student.dob,
        gender: student.gender,
        startDate: student.startDate,
        rank: student.rank,
        testNumber: student.testNumber,
        beltSize: student.beltSize,
        ITFnumber: student.ITFnumber,
        lastTest: student.lastTest,
        referral: student.referral,
        active: true
      })
      .then(docRef => {
        id = docRef.id;
        console.log("Student created with ID: ", id);
      })
      .catch(error => {
        console.error("Error creating student: ", error);
      });
  },
  updateStudent({
    commit
  }, student) {
    let id = 0;

    firebase.firestore().collection('students').doc(student.id).update({
      nameFirst: student.nameFirst,
      nameLast: student.nameLast,
      email: student.email,
      phone: student.phone,
      cellPhone: student.cellPhone,
      emergencyPhone: student.emergencyPhone,
      gender: student.gender,
      dob: student.dob,
      ITFnumber: student.ITFnumber,
      rank: student.rank,
      testNumber: student.testNumber,
      beltSize: student.beltSize,
      startDate: student.startDate,
      lastTest: student.lastTest,
      address: student.address,
      city: student.city,
      state: student.state,
      zip: student.zip
    }).then(docRef => {
      console.log("Student profile info has been updated.");
      commit("setStudent", student);
    }).catch(error => {
      console.error(error);
    });
  },
  toggleStudentStatus({
    commit
  }, {
    student,
    status
  }) {
    firebase.firestore().collection('students').doc(student.id).update({
      active: status
    }).then(docRef => {
      console.log("Student active status updated to " + status);
      student.active = status;
      commit("setStudent", student);
    }).catch(error => {
      console.error(error);
    });
  },
  deleteStudent({
      commit
    },
    student
  ) {
    firebase.firestore().collection('students').doc(student.id).delete().then(() => {
      console.log("Deleted student.");
    }).catch(error => {
      console.error(error);
    });
  },
};

const mutations = {
  setStudent(state, student) {
    state.student = student;
  },
  setStudents(state, students) {
    state.students = students;
  },
  setAgeData(state, data) {
    state.ageData.series[0].data = Object.values(data);
  },
  setRankData(state, data) {
    state.rankData.series = Object.values(data);
  },
  setGenderData(state, data) {
    state.genderData.series = Object.values(data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};

function calcAge(dob) {
  var today = new Date();
  var birthDate = new Date(dob);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}